import { LazyLoadImage } from "react-lazy-load-image-component";
import { useParams } from "react-router-dom";
import { defaultImg } from "src/assets/images";
import {
    muiz, muiz1, muiz2, muiz3, muiz4, muiz5, muiz6, muiz7, muiz8, muiz9,
    ayomide, ayomide1, ayomide2, ayomide3, ayomide4, ayomide5,
    fasasi, fasasi1, fasasi2, fasasi3, fasasi4, joshua, joshua1, wumi, wumi1, wumi2, wumi3, wumi4, wumi5, wumi6
} from "src/assets/images";
import Footer from "src/components/Footer";
import Navbar from "src/components/Navbar";

const Lookbook = () => {
    const { id } = useParams();

    const usersInfo = [
        {
            id: "1",
            name: "Akinyemi Muiz",
            bio: "Akinyemi Muiz is a vibrant and charismatic individual with a passion for African culture and fashion. With a keen eye for style and a love for Ankara prints, Muiz embodies the spirit of our brand. As an ambassador for our company, Muiz represents our commitment to bringing the beauty and richness of African culture to the world through our stunning Ankara designs.With his infectious enthusiasm and dedication to our brand, Muiz will help spread the word about our unique and stylish products, inspiring others to join the Ankara revolution!",
            image: muiz,
            otherImages: [muiz, muiz1, muiz2, muiz3, muiz4, muiz5, muiz6, muiz7, muiz8, muiz9] // Add these imports at the top
        },
        {
            id: "2",
            name: "Ayomide",
            bio: "Ayomide is a charismatic and confident individual with a passion for fashion and a love for Ankara prints. With a strong sense of style and a connection to African culture, Ayomide is an excellent fit for our brand. As an ambassador for our company, Ayomide represents our passion for promoting African culture and creativity through our vibrant Ankara designs.With her outgoing personality and commitment to our brand, Ayomide will help showcase our products to a wider audience, inspiring others to discover the beauty and diversity of African fashion.",
            image: ayomide,
            otherImages: [ayomide1, ayomide2, ayomide3, ayomide4, ayomide5] // Add these imports at the top
        },
        {
            id: "3",
            name: "Fasasi Roheemah",
            bio: "Fasasi Roimat is a creative and confident individual with a flair for fashion and a deep appreciation for African heritage. With a strong sense of style and a love for Ankara prints, Roimat is the perfect fit for our brand. As an ambassador for our company, Roimat represents our passion for celebrating African culture and creativity through our vibrant Ankara designs. With her outgoing personality and commitment to our brand, Roimat will help showcase our products to a wider audience, promoting the beauty and diversity of African fashion.",
            image: fasasi,
            otherImages: [fasasi1, fasasi2, fasasi3, fasasi4]
        },
        {
            id: "4",
            name: "Joshua",
            bio: "Ashibo Joshua is a dynamic and charismatic individual with a passion for fashion and a love for Ankara prints. With a keen sense of style and a strong connection to African culture, Joshua is an excellent ambassador for our brand. As an ambassador for our company, Joshua represents our dedication to bringing African culture and fashion to the forefront.With his enthusiasm and creativity, Joshua will help promote our brand and products, inspiring others to explore the world of Ankara and discover the beauty of African fashion..",
            image: joshua,
            otherImages: [joshua, joshua1]
        },
        {
            id: "5",
            name: "Omowumi Basit",
            bio: "Omowumi Basit's is a vibrant and stylish individual with a deep love for African culture and fashion. With a keen eye for detail and a passion for Ankara prints, Basit’s is a fantastic ambassador for our brand. As an ambassador for our company, Basit’s represents our commitment to celebrating African heritage and creativity through our stunning Ankara designs.With her warm personality and dedication to our brand, Basit’s will help build a strong community of Ankara enthusiasts, promoting the beauty and richness of African fashion.",
            image: wumi,
            otherImages: [wumi1, wumi2, wumi3, wumi4, wumi5, wumi6]
        }
    ];

    const user = usersInfo.find((user) => user.id === id);

    return (
        <>
            <Navbar />
            <div className="container py-10">
                <h1 className="lookbook-heading-title">Lookbook</h1>

                {user ? (
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-center">
                        <div className="w-full h-64 lg:h-full">
                            <LazyLoadImage
                                src={user.image}
                                alt={user.name}
                                // effect="blur"
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = defaultImg;
                                }}
                                className="w-full h-full object-cover rounded-lg object-[50%_20%]"
                                placeholderSrc={defaultImg}
                            />
                        </div>
                        <div className="bg-black text-white flex flex-col justify-center h-64 lg:h-full p-6 rounded-lg plan-a-fatix">
                            <h2 className="text-4xl font-bold mb-2">{user.name}</h2>
                            <p className="mb-4 person-info-text">{user.bio}</p>
                        </div>
                    </div>


                ) : (
                    <p className="text-center text-red-500">User not found</p>
                )}

                {user && user.otherImages && user.otherImages.length > 0 && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
                        {user.otherImages.map((img, index) => (
                            <div key={index}>
                                <LazyLoadImage
                                    src={img}
                                    alt={`${user.name} - ${index + 1}`}
                                    // effect="blur"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = defaultImg;
                                    }}
                                    className="w-full  object-cover rounded-lg display-lower-img-lookbook"
                                    placeholderSrc={defaultImg}
                                />
                            </div>
                        ))}
                    </div>
                )}



            </div>
            <Footer />
        </>
    );
};

export default Lookbook;
